export default function extractKeys<T extends Record<string, unknown>>(values: T[]) {
  return values.reduce<string[]>((acc, value) => Array.from(new Set([...acc, ...Object.keys(value)])), []);
}
